import MetaHeader from '../components/common/MetaHeader';
import ALink from '../components/common/ALink';

export default function TermsCondition() {
  return (
    <>
    <MetaHeader title={'Terms Condition'}/>
    <main className="main">
      <nav aria-label="breadcrumb" className="breadcrumb-nav mb-0">
        <div className="container">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <ALink href="/">Home</ALink>
            </li>
            <li className="breadcrumb-item">
              <ALink href="#">Pages</ALink>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Terms & Condition
            </li>
          </ol>
        </div>
      </nav>

      <div className="container">
        <div className="subpage">
          <h1 className="subpage__title">Terms & Condition</h1>
          <div className="subpage__section">
            <p className="subpage__paragraph">
              Agreement between User and Dorado Management LLC d/b/a
              BuyOnTrust.com
            </p>
            <br></br>
            <p className="subpage__paragraph">
              Dorado Management LLC d/b/a BuyOnTrust.com its divisions,
              subsidiaries, and/or affiliates (collectively, “Buy on Trust” or
              “we” or “us”) provide website features and other products and
              services to you when you (1) visit or shop at buyontrust (the
              Website), (2) use Buy on Trust’s services online, through any Buy
              on Trust mobile application, or in any other electronic medium,
              (3) use any Buy on Trust mobile applications, (4) manage your
              account electronically, make online payments, use promotional
              offers electronically, enter contests and sweepstakes
              electronically, manage deliveries electronically, request service
              electronically, (5) visit or shop at any other website or
              application owned or operated by us, contact customer service
              representatives, or (6) use software provided by us in connection
              with any of the foregoing (collectively, “Buy on Trust Services”).
              The Buy on Trust Services are provided as a service to our
              customers. Please review these Terms of Service that govern your
              use of the Buy on Trust Services. The Buy on Trust Services are
              offered to you conditioned on your acceptance without modification
              of the terms, conditions, and notices contained herein.
            </p>
            <br></br>
            <p className="subpage__paragraph">
              Please read these Terms of Service carefully. By using any of the
              Buy on Trust Services, you: (i) agree to all such terms,
              conditions, and notices; (ii) acknowledge that you have read and
              understood these Terms of Service; (iii) represent that you are 18
              or older; (iv) consent to be legally bound by these Terms of
              Service; and (v) consent and agree to the contents of Buy on Trust
              Privacy Policy described below. If you do not agree to these Terms
              of Service, do not use the Buy on Trust Services or download any
              applications.
            </p>
            <br></br>
            <p className="subpage__paragraph ">
              <strong>IMPORTANT:</strong> PLEASE REVIEW THE ARBITRATION AGREEMENT SET FORTH BELOW
              CAREFULLY, AS IT WILL REQUIRE YOU TO RESOLVE DISPUTES WITH BUY ON
              TRUST ON AN INDIVIDUAL BASIS THROUGH FINAL AND BINDING
              ARBITRATION. BY ENTERING THIS AGREEMENT, YOU EXPRESSLY ACKNOWLEDGE
              THAT YOU HAVE READ AND UNDERSTAND ALL OF THE TERMS OF THIS
              AGREEMENT AND HAVE TAKEN THE TIME TO CONSIDER THE CONSEQUENCES OF
              THIS IMPORTANT DECISION.
            </p>
          </div>

          <div className="subpage__section">
            <ol className="subpage__list--ordered bold">
              <li>
                <b>PRIVACY</b>
                <p className="subpage__paragraph">
                  We respect the privacy of our visitors to and users of the Buy
                  on Trust Services. Please review our Privacy Policy located
                  here. By accessing, downloading, installing, using, and
                  providing information to or through the Buy on Trust Services,
                  you consent to the data handling practices relating to Buy on
                  Trust methods of collection, processing, disclosure,
                  retention, and destruction of data as set forth in the most
                  current version of Buy on Trust Privacy Policy.
                </p>
              </li>
              <li>
                <b>MODIFICATION/ADDITIONS TO TERMS OF SERVICE</b>
                <p className="subpage__paragraph">
                  We reserve the right to change the terms, conditions, and
                  notices under which the Buy on Trust Services are offered,
                  including but not limited to any charges associated with the
                  use of the Buy on Trust Services. At certain places within the
                  Buy on Trust Services, there may be additional or other terms,
                  conditions, and policies that apply to your use of that
                  Service. By using those Buy on Trust Services, you agree to
                  abide by those terms, conditions, and policies. We may change
                  those terms and policies from time to time. Buy on Trust will
                  not “retroactively” change these Terms of Service, and any
                  modifications Buy on Trust makes shall take effect
                  proactively, once you next access the Buy on Trust Services.
                  By continuing to use the Buy on Trust Services after we post
                  any changes, you accept and agree to those terms, conditions,
                  and policies, as modified. Please feel free to print out a
                  copy of this Agreement for your records.
                </p>
              </li>
              <li>
                <b>THIRD PARTY CONTENT AND LINKS TO THIRD PARTY SITES</b>
                <p className="subpage__paragraph">
                  The Buy on Trust Services may display, include, or make
                  available third-party content (including data, information,
                  applications, and other products, services, and/or materials)
                  or contain links to the sites of others, including, but not
                  limited to, unaffiliated third-party vendors and promotional
                  partners (“Third-Party Materials”). The Third-Party Materials
                  may contain our trademarks, logos, and intellectual property
                  as we may license third parties this right from time to time.
                  Regardless, the Third-Party Materials are not under our
                  control and we are not responsible for the contents of any
                  Third-Party Materials, including without limitation any
                  content or link contained in Third-Party Materials, or any
                  changes or updates to Third-Party Materials. We are not
                  responsible for webcasting or any other form of transmission
                  received from any Third-Party Materials. We are providing the
                  content and links to you only as a convenience, and the
                  inclusion of any content or link does not imply endorsement by
                  us of the Third-Party Materials or any association with the
                  owners or operators of the Third-Party Materials. You
                  acknowledge and agree that Buy on Trust is not responsible for
                  Third-Party Materials, including its accuracy, completeness,
                  timeliness, validity, intellectual property compliance,
                  legality, decency, quality, or any other aspect thereof. Buy
                  on Trust does not assume and will not have any liability or
                  responsibility to you or any other person or entity for any
                  Third-Party Materials. Your access to and use of Third-Party
                  Materials is entirely at your own risk and subject to each
                  third party’s terms and conditions.
                </p>
              </li>
              <li>
                <b>REGISTRATION/ACKNOWLEDGEMENT</b>
                <p className="subpage__paragraph">
                  We may use web beacons, pixel tags, .gif files, and the like,
                  that allow for the collection of information about your
                  interactions on the Buy on Trust Services. These technologies
                  may be used, for example, to place advertisements, to
                  understand site traffic patterns and the number of visitors to
                  the Buy on Trust Services, and to measure the effectiveness of
                  advertisements or the Buy on Trust Services. Web beacons, and
                  the like, also enable third-parties involved in advertising
                  operations to recognize your browser as you navigate to other
                  websites and are necessary for the online delivery or
                  placement of certain types of ads. By accepting these terms
                  you provide your prior consent for Buy on Trust to collect
                  this information from any device you use to access the Buy on
                  Trust Services, including but not limited to, Buy on
                  Trust-leased devices, devices leased by Buy on Trust
                  subsidiaries or affiliates, user-owned devices, or devices
                  owned by third parties.
                </p>
              </li>
              <li>
                <b>NO UNLAWFUL OR PROHIBITED USE</b>
                <p className="subpage__paragraph">
                  As a condition of your use of the Buy on Trust Services, you
                  warrant to us that you will not use the Buy on Trust Services
                  for any purpose that is unlawful or prohibited by these Terms
                  of Service. You may not use Buy on Trust Services in any
                  manner which could damage, disable, overburden, or impair the
                  Buy on Trust Services or interfere with any other party’s use
                  and enjoyment of the Buy on Trust Services. You may not obtain
                  or attempt to obtain any materials or information through any
                  means not intentionally made available or provided for through
                  the Buy on Trust Services.
                </p>
              </li>
              <li>
                <b>
                  MATERIALS PROVIDED TO OR POSTED ON THE BUY ON TRUST SERVICES
                </b>
                <p className="subpage__paragraph">
                  You may post reviews, comments, photos, videos, and other
                  content, and submit suggestions, ideas, comments, questions,
                  or other information, so long as the content is not illegal,
                  obscene, threatening, defamatory, invasive of privacy,
                  infringing of intellectual property rights (including
                  publicity rights), or otherwise injurious to third parties or
                  objectionable, and does not consist of or contain software
                  viruses, political campaigning, commercial solicitation, chain
                  letters, mass mailings, or any form of “spam” or unsolicited
                  commercial electronic messages. You may not use a false e-mail
                  address, impersonate any person or entity, or otherwise
                  mislead as to the origin of the content you share, post, or
                  submit. Buy on Trust reserves the right (but not the
                  obligation) to remove or edit such content but does not
                  regularly review posted content. We do not claim ownership of
                  the content or materials that you provide to us, but if you do
                  provide, post, upload, input, or submit content or materials
                  (including without limitation, reviews, photos, comments,
                  video, feedback, suggestions, or other content), you hereby
                  grant Buy on Trust and any affiliated third parties,
                  franchisees, sublicensees, unaffiliated third party vendors,
                  and promotional partners, a nonexclusive, royalty-free,
                  worldwide, perpetual, irrevocable, and fully sublicensable
                  right to use, repost, reproduce, transmit, modify, adapt,
                  publish, perform, translate, reformat, create derivative works
                  from, distribute, and display such content and materials in
                  any type of media for any purpose whatsoever, and combine such
                  content and materials with data from other websites, mobile
                  applications, and sources. You grant Buy on Trust and
                  sublicensees the right to use the name that you submit in
                  connection with such content, if we choose, along with your
                  city and state/province. No compensation will be paid with
                  respect to the use of your content or materials as provided
                  herein. By posting, inputting, providing or submitting content
                  or materials, you represent and warrant that you own or
                  otherwise control all of the rights to such content and
                  materials, that the content or materials are accurate, that
                  use of the content or materials that you supply does not
                  violate these Terms of Service and will not cause injury to
                  any person or entity, and that you will indemnify Buy on Trust
                  for all claims resulting from content or materials that you
                  supply. Buy on Trust has the right but not the obligation to
                  monitor and edit or remove any materials, activity, or
                  content. Buy on Trust takes no responsibility and assumes no
                  liability for any content or materials posted by you or any
                  third party. We are under no obligation to post or use any
                  content or materials you may provide and may remove any
                  content or materials at any time in our sole discretion. We
                  reserve the right at all times to disclose any information
                  regarding any content or materials as necessary to satisfy any
                  applicable law, regulation, legal process, or governmental
                  request, in our sole discretion.
                </p>
              </li>
              <li>
                <b>COPYRIGHT AND TRADEMARK NOTICES</b>
                <p className="subpage__paragraph">
                  All content included in or made available through the Buy on
                  Trust Services, such as text, graphics, logos, button icons,
                  images, audio clips, digital downloads, data compilations, and
                  software is the property of Buy on Trust or its content
                  suppliers and protected by United States and international
                  copyright laws. The compilation of all content included in or
                  made available through the Buy on Trust Services is the
                  exclusive property of Buy on Trust and protected by U.S. and
                  international copyright laws. All rights reserved.
                </p>
              </li>
              <li>
                <b>TRADEMARKS</b>
                <p className="subpage__paragraph">
                  The trademarks, trade dress, logos, and service marks
                  displayed on the Buy on Trust Services (collectively the
                  “Trademarks”) are our registered and unregistered trademarks
                  or those of our affiliates or suppliers in the U.S. and other
                  countries. Under no circumstances may you copy, alter, modify,
                  or change the Trademarks. Nothing contained in the Buy on
                  Trust Services should be construed as granting any license or
                  right to use any of the Trademarks without our express
                  permission. Any rights not expressly granted herein are
                  reserved. All trademarks not owned by Buy on Trust that appear
                  in any of the Buy on Trust Services are the property of their
                  respective owners.
                </p>
              </li>
              <li>
                <b>PATENTS</b>
                <p className="subpage__paragraph">
                  One or more patents owned by Buy on Trust may apply to the Buy
                  on Trust Services and/or to the products, features and
                  services accessible via the Buy on Trust Services.
                </p>
              </li>
              <li>
                <b>INTELLECTUAL PROPERTY INFRINGEMENT</b>
                <p className="subpage__paragraph">
                  Buy on Trust respects the intellectual property of others. If
                  you believe that your intellectual property rights are being
                  infringed, please submit written claims to:
                </p>
                <br></br>
                <i>Buy on Trust Legal Department</i>
                <br></br>
                <i>1434 Spruce Street</i>
                <br></br>
                <i>Suite 100,</i>
                <br></br>
                <i>Boulder, CO 80302</i>
                <br></br>
                <br></br>
                <i>
                  Phone:
                  <a
                    href="tel:+18882747732"
                    style={{
                      marginLeft: '4px',
                      color: '#4f4f4f',
                      fontWeight: '600'
                    }}>
                    (888) 274-7732
                  </a>
                </i>
                <br></br>
                <i>
                  Email:
                  <a
                    href="mailto:info@buyontrust.com"
                    style={{
                      marginLeft: '4px',
                      color: '#4f4f4f',
                      fontWeight: '600'
                    }}>
                    info@buyontrust.com
                  </a>
                </i>
                <br></br>
                <br></br>
                <p className="subpage__paragraph">
                  Written claims concerning infringement must include the
                  following information:
                </p>
                <br></br>
                <ol className="subpage__list--ordered no-gap">
                  <li>
                    A physical or electronic signature of the person authorized
                    to act on behalf of the owner of the intellectual property
                    interest;
                  </li>
                  <li>
                    A description of the work that you claim has been infringed
                    upon;
                  </li>
                  <li>
                    A description of where the material that you claim is
                    infringing is located within the Buy on Trust Services;
                  </li>
                  <li>Your address, telephone number, and e-mail address;</li>
                  <li>
                    A statement by you that you have a good-faith belief that
                    the disputed use is not authorized by the owner, its agent,
                    or the law;
                  </li>
                  <li>
                    A statement by you, made under penalty of perjury, that the
                    above information in your notice is accurate and that you
                    are the owner or authorized to act on the owner’s behalf.
                  </li>
                </ol>
              </li>
              <li>
                <b>LICENSE AND ACCESS</b>
                <p className="subpage__paragraph">
                  You acknowledge and agree that the Buy on Trust Services are
                  licensed, not sold, to you. All right, title and interest in
                  the Buy on Trust Services and any content contained herein is
                  our exclusive property, except as otherwise stated. Subject to
                  your strict compliance with these Terms of Service (and your
                  payment of any fees, if applicable), Buy on Trust grants you a
                  limited, non-exclusive, non-transferable, non-sublicensable
                  license to access, stream, download, install, and make
                  personal and non-commercial use, as applicable and at your
                  expense, of the Buy on Trust Services. This license does not
                  include any resale or commercial use of any of the Buy on
                  Trust Services, or its contents, any collection and use of any
                  product listings, descriptions, or prices, any derivative use
                  of any of the Buy on Trust Services or its contents, any
                  downloading, copying, or other use of account information for
                  the benefit of any third party, or any use of data mining,
                  scraping, robots, or similar data gathering and extraction
                  tools. In addition, this license does not allow you to:
                </p>
                <br></br>
                <ol className="subpage__list--ordered no-gap">
                  <li>
                    use the Buy on Trust Services on any devices that you do not
                    own or have a right to control and operate;
                  </li>
                  <li>copy the Buy on Trust Services;</li>
                  <li>
                    modify, translate, adapt, or otherwise create derivative
                    works or improvements, whether or not patentable, of the Buy
                    on Trust Services;
                  </li>
                  <li>
                    reverse engineer, disassemble, decompile, decode, or
                    otherwise attempt to derive or gain access to the source
                    code of the Buy on Trust Services or any part of the Buy on
                    Trust Services;
                  </li>
                  <li>
                    remove, delete, alter, or obscure any trademarks or any
                    copyright, patent, or other intellectual property or
                    proprietary rights notices from the Buy on Trust Service,
                    including any copy of these notices;
                  </li>
                  <li>
                    rent, lease, lend, sell, sublicense, assign, distribute,
                    publish, transfer, or otherwise make available the Buy on
                    Trust Services, or any features or functionality of the Buy
                    on Trust Services, to any third party for any reason.
                  </li>
                </ol>
                <br></br>
                <p className="subpage__paragraph">
                  All rights not expressly granted to you in these Terms of
                  Service are reserved and retained by Buy on Trust or its
                  licensors, suppliers, publishers, rightsholders, or other
                  content providers. None of the Buy on Trust Services, nor any
                  part of the Buy on Trust Services, may be reproduced,
                  duplicated, copied, sold, resold, visited, or otherwise
                  exploited for any commercial purpose without express written
                  consent of Buy on Trust. You may not frame or utilize framing
                  techniques to enclose any trademark, logo, or other
                  proprietary information (including images, text, page layout,
                  or form) of Buy on Trust without express written consent. You
                  may not use any meta tags or any other “hidden text” utilizing
                  Buy on Trust name or trademarks without the express written
                  consent of Buy on Trust. You may not misuse the Buy on Trust
                  Services.
                </p>
              </li>
              <li>
                <b>TERMINATION/ACCESS RESTRICTION</b>
                <p className="subpage__paragraph">
                  We reserve the right, in our sole discretion, to terminate
                  your access to the Buy on Trust Services and the related
                  services or any portion thereof at any time, without notice.
                </p>
              </li>
              <li>
                <b>ADDITIONAL SOFTWARE TERMS</b>
                <p className="subpage__paragraph">
                  The following terms (“Software Terms”) apply to any software
                  (including any updates or upgrades to the software) and any
                  related documentation we make available to you in connection
                  with the Buy on Trust Services, including any mobile
                  application we make available to you (the “Buy on Trust
                  Software”).
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  Use of the Buy on Trust Software. You may use Buy on Trust
                  Software solely for purposes of enabling you to use the Buy on
                  Trust Services as provided by Buy on Trust, and as permitted
                  by these Terms of Service. You may not incorporate any portion
                  of the Buy on Trust Software into other programs or compile
                  any portion of it in combination with other programs, or
                  otherwise copy (except to exercise rights granted in this
                  section), modify, create derivative works of, distribute,
                  assign any rights to, or license the Buy on Trust Software in
                  whole or in part. All software used in the Buy on Trust
                  Services is the property of Buy on Trust or its software
                  suppliers and is protected by United States and international
                  copyright laws.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  Use of Third Party Services. When you use the Buy on Trust
                  Software, you may also be using the services of one or more
                  third parties, such as a wireless carrier or a mobile software
                  provider. Your use of those third-party services may be
                  subject to the separate policies, terms of use, and fees of
                  those third parties.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  • No Reverse Engineering. You may not reverse engineer,
                  decompile or disassemble, tamper with, or bypass any security
                  associated with the Buy on Trust Software, whether in whole or
                  in part.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  Updates. We may from time to time in its sole discretion offer
                  automatic or manual updates to the Buy on Trust Services and
                  Buy on Trust Software without notice to you. Updates may
                  include upgrades, bug fixes, patches, other error corrections,
                  and new features. Such updates may also modify or delete in
                  their entirely certain features and functionality. You agree
                  that Buy on Trust has no obligation to provide any updates or
                  to continue to provide or enable any particular features or
                  functionality. Based on your device settings, when connected
                  to the internet, the Buy on Trust Services will either
                  automatically download and install all available updates, or
                  you may receive notice of or be prompted to download and
                  install available updates. You agree to promptly download and
                  install all updates and acknowledge and agree that the Buy on
                  Trust Services or portions thereof may not properly operate
                  should you fail to do so. You further agree that all updates
                  are deemed part of the Buy on Trust Services and are subject
                  to all terms and conditions of this Agreement.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  Government End Users. If you are a U.S. Government end user,
                  we are licensing the Buy on Trust Software to you as a
                  “Commercial Item” as that term is defined in the U.S. Code of
                  Federal Regulations (see 48 C.F.R. § 2.101), and the rights we
                  grant you to the Buy on Trust Software are the same as the
                  rights we grant to all others under these Terms of Service.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  Conflicts. In the event of any conflict between these Terms of
                  Service and any other Buy on Trust or third-party terms
                  applicable to any portion of Buy on Trust Software, such as
                  open-source license terms, such other terms will control as to
                  that portion of the Buy on Trust Software and to the extent of
                  the conflict.
                </p>
              </li>
              <li>
                <b>YOUR ACCOUNT</b>
                <p className="subpage__paragraph">
                  You may need an Buy on Trust account to use certain Buy on
                  Trust Services, and you may be required to be logged into the
                  account and have a valid payment method associated with it. If
                  there is a problem charging your selected payment method, we
                  may charge any other valid payment method associated with your
                  account. You are responsible for maintaining the
                  confidentiality of your account and password and for
                  restricting access to your account, and you agree to accept
                  responsibility for all activities that occur under your
                  account or password. Your credentials should be unique,
                  difficult to guess, different from your other credentials, and
                  should not be shared with others. Buy on Trust does not sell
                  or lease products or provide services to children. Buy on
                  Trust reserves the right to refuse service, terminate
                  accounts, terminate your rights to use the Buy on Trust
                  Services, remove or edit content, or cancel orders in its sole
                  discretion.
                </p>
              </li>
              <li>
                <b>DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY</b>
                <p className="subpage__paragraph">
                  THE INFORMATION, CONTENT, SOFTWARE, APPLICATIONS, PRODUCTS,
                  AND SERVICES INCLUDED IN OR AVAILABLE THROUGH THE BUY ON TRUST
                  SERVICES MAY INCLUDE INACCURACIES OR ERRORS. CHANGES ARE
                  PERIODICALLY MADE TO THE BUY ON TRUST SERVICES AND WE MAY MAKE
                  CHANGES TO THE BUY ON TRUST SERVICES AT ANY TIME. ADVICE
                  RECEIVED VIA THE BUY ON TRUST SERVICES SHOULD NOT BE RELIED
                  UPON FOR PERSONAL, LEGAL, OR FINANCIAL DECISIONS AND YOU
                  SHOULD CONSULT AN APPROPRIATE PROFESSIONAL FOR SPECIFIC ADVICE
                  TAILORED TO YOUR SITUATION. YOU ACKNOWLEDGE THAT THERE ARE
                  INHERENT RISKS TO PROVIDING PERSONAL INFORMATION AND ACCOUNT
                  NUMBERS OVER THE INTERNET. ALWAYS USE CAUTION WHEN GIVING OUT
                  ANY PERSONALLY IDENTIFYING INFORMATION ABOUT YOURSELF. YOU
                  AGREE TO DETERMINE WHETHER THE BUY ON TRUST SERVICES ARE
                  SUFFICIENTLY SECURE TO MEET YOUR NEEDS. YOU UNDERSTAND THAT
                  YOU ARE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER
                  SYSTEM OR LOSS OF DATA THAT RESULTS FROM ANY MATERIAL AND/OR
                  DATA ACCESSED OR DOWNLOADED FROM OR OTHERWISE PROVIDED THROUGH
                  THE BUY ON TRUST SERVICES. THE BUY ON TRUST SERVICES AND ALL
                  INFORMATION, SOFTWARE, APPLICATIONS, PRODUCTS, SERVICES, AND
                  RELATED GRAPHICS ARE PROVIDED “AS IS” WITHOUT WARRANTY OR
                  CONDITION OF ANY KIND. NEITHER WE NOR OUR SUPPLIERS MAKE ANY
                  REPRESENTATIONS OR WARRANTIES ABOUT THE SUITABILITY,
                  RELIABILITY, AVAILABILITY, TIMELINESS, AND ACCURACY OF THE
                  INFORMATION, SOFTWARE, APPLICATIONS, PRODUCTS, SERVICES, AND
                  RELATED GRAPHICS CONTAINED IN THE BUY ON TRUST SERVICES FOR
                  ANY PURPOSE. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE
                  LAW, BUY ON TRUST, ON ITS OWN BEHALF AND ON BEHALF OF ITS
                  AFFILIATES, FRANCHISEES, AND ITS AND THEIR RESPECTIVE
                  LICENSORS AND SERVICE PROVIDERS, EXPRESSLY DISCLAIM ALL
                  WARRANTIES, WHETHER WRITTEN, ORAL, EXPRESS, IMPLIED, LEGAL,
                  STATUTORY, CONTRACTUAL, EXTRA-CONTRACTUAL, DELICTUAL OR IN
                  TORT, AND WHETHER ARISING BY LAW, STATUTE, USAGE OF TRADE,
                  CUSTOM, COURSE OF DEALING OR PERFORMANCE, OR THE PARTIES’
                  CONDUCT OR COMMUNICATION WITH ONE ANOTHER, OR AS A RESULT OF
                  THE NATURE OF THIS AGREEMENT OR IN CONFORMITY WITH USAGE,
                  EQUITY OR LAW, OR OTHERWISE, INCLUDING WITHOUT LIMITATION ALL
                  IMPLIED WARRANTIES OR CONDITIONS OF MERCHANTABILITY,
                  WORKMANSHIP, CONFORMITY, FITNESS FOR A PARTICULAR PURPOSE OR
                  GENERAL PURPOSE, TITLE, OWNERSHIP, AND NON-INFRINGEMENT. TO
                  THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT
                  SHALL WE, AND EACH OF OUR RESPECTIVE OFFICERS, DIRECTORS,
                  EMPLOYEES, AGENTS, LICENSORS, FRANCHISEES, REPRESENTATIVES,
                  AGENCIES, AND SUPPLIERS, BE LIABLE FOR ANY DIRECT, INDIRECT,
                  PUNITIVE, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES OR ANY
                  DAMAGES WHATSOEVER INCLUDING, WITHOUT LIMITATION, (I) DAMAGES
                  FOR LOSS OF USE, DATA, PROFITS, REVENUE, OR GOODWILL, (II) THE
                  COSTS OF PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES, (III)
                  PERSONAL INJURY, (IV) PROPERTY DAMAGE, (V) BUSINESS
                  INTERRUPTION, OR (VI) COMPUTER, MOBILE DEVICE, OR ELECTRONIC
                  DEVICE FAILURE OR MALFUNCTION, ARISING OUT OF OR IN ANY WAY
                  CONNECTED WITH THE USE OR PERFORMANCE OF THE BUY ON TRUST
                  SERVICES, WITH THE DELAY OR INABILITY TO USE THE BUY ON TRUST
                  SERVICES OR RELATED SERVICES, THE PROVISION OF OR FAILURE TO
                  PROVIDE THE BUY ON TRUST SERVICES, OR FOR ANY INFORMATION,
                  SOFTWARE, PRODUCTS, APPLICATIONS, SERVICES AND RELATED
                  GRAPHICS OBTAINED THROUGH THE BUY ON TRUST SERVICES, OR
                  OTHERWISE ARISING OUT OF THE USE OF THE BUY ON TRUST SERVICES,
                  WHETHER BASED ON CONTRACT, EXTRA-CONTRACTUAL LIABILITY, TORT,
                  NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, REGARDLESS OF
                  WHETHER SUCH DAMAGES WERE FORESEEABLE, AND EVEN IF WE OR ANY
                  OF OUR OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, LICENSORS,
                  REPRESENTATIVES, FRANCHISEES, AGENCIES, OR SUPPLIERS HAVE BEEN
                  ADVISED OF THE POSSIBILITY OF DAMAGES. BECAUSE SOME
                  STATES/JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION
                  OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, THE
                  ABOVE LIMITATION MAY NOT APPLY TO YOU. IN SUCH
                  STATES/JURISDICTIONS, OUR LIABILITY IS LIMITED TO THE FULLEST
                  EXTENT PERMITTED BY SUCH LOCAL LAW. IF YOU ARE DISSATISFIED
                  WITH ANY PORTION OF THE BUY ON TRUST SERVICES, OR WITH ANY OF
                  THESE TERMS OF SERVICE, YOUR SOLE AND EXCLUSIVE REMEDY IS TO
                  DISCONTINUE USING THE BUY ON TRUST SERVICES.
                </p>
              </li>
              <li>
                <b>INDEMNIFICATION</b>
                <p className="subpage__paragraph">
                  You agree to defend, indemnify, and hold Buy on Trust harmless
                  (including our parents, subsidiaries, franchisees, and
                  affiliates, and all of our and their respective officers,
                  directors, employees, agents, licensors, and suppliers)
                  against all claims, losses, expenses, damages and costs
                  (including reasonable attorneys’ fees) arising from or related
                  to your use of the Buy on Trust Services or breach of these
                  Terms of Service. At our expense and election, we reserve the
                  right to assume the exclusive defense and control of any
                  matter subject to indemnification by you and you agree to
                  cooperate with us in connection with our defense. Your
                  indemnification obligation shall survive the termination of
                  these Terms of Service.
                </p>
              </li>
              <li>
                <b>DISPUTES/ARBITRATION/CLASS ACTION WAIVER</b>
                <br></br>
                <br></br>
                <ol className="subpage__list--ordered">
                  <li>
                    <b>
                      DISPUTES SUBJECT TO INDIVIDUAL ARBITRATION/ CLASS ACTION
                      WAIVER
                    </b>
                    <p className="subpage__paragraph">
                      YOU AND WE AGREE THAT ANY AND ALL DISPUTES ARISING OUT OF
                      OR RELATING IN ANY WAY TO THE BUY ON TRUST SERVICES
                      (“Disputes”) SHALL BE RESOLVED EXCLUSIVELY IN BINDING
                      ARBITRATION RATHER THAN LITIGATION IN COURT. This
                      Agreement to arbitrate applies to all Disputes, whether
                      based in contract, tort, statute, or any other legal or
                      equitable theory. Notwithstanding this Arbitration
                      Agreement, you or Buy on Trust may bring Disputes in an
                      appropriate small claims court so long as the relief
                      requested falls within the jurisdiction of the small
                      claims court, but neither you nor Buy on Trust may bring
                      claims in any other court. You and we agree that any
                      questions about the scope or enforceability of this
                      Arbitration Agreement will be decided by a court, not the
                      arbitrator. You agree that we may file a lawsuit in court
                      to enjoin infringement or other misuse of intellectual
                      property rights. YOU AND WE EXPRESSLY AGREE THAT ANY
                      DISPUTE RESOLUTION WILL BE CONDUCTED ONLY ON AN INDIVIDUAL
                      BASIS AND NOT IN A CLASS, CONSOLIDATED, OR REPRESENTATIVE
                      ACTION. YOU EXPRESSLY WAIVE ANY ABILITY TO BRING A CLASS
                      OR REPRESENTATIVE ACTION IN ARBITRATION OR TO SEEK RELIEF
                      ON BEHALF OF A CLASS IN ARBITRATION. YOU ALSO EXPRESSLY
                      WAIVE ANY RIGHT TO BRING A CLASS ACTION IN COURT OR TO
                      PARTICIPATE OR OBTAIN BENEFITS IN A CLASS ACTION SOMEONE
                      ELSE BRINGS IN COURT. You and we acknowledge that this
                      class action waiver is integral to the Arbitration
                      Agreement. If a court or arbitrator determines that the
                      class action waiver is invalid or unenforceable, you and
                      we both agree that this Arbitration Agreement will not
                      apply, and any Dispute shall be resolved in court. That
                      is, you and we agree that this class action waiver cannot
                      be severed from this Arbitration Agreement. It is the
                      express intention of both parties not to proceed with any
                      Dispute by way of class arbitration. We also both agree
                      that you or we may bring suit to enjoin infringement or
                      other misuse of intellectual property rights. Arbitration
                      is a process to resolve disputes before a neutral person
                      (an arbitrator) instead of having a trial in court with a
                      judge and/or jury. THEREFORE, BY ENTERING INTO THIS
                      ARBITRATION AGREEMENT, YOU ARE WAIVING YOUR RIGHTS TO
                      TRIAL BY JURY. YOU ARE ALSO WAIVING YOUR RIGHTS TO BRING
                      CLAIMS IN COURT AND TO BRING OR PARTICIPATE IN A CLASS
                      ACTION. An arbitrator can award the same damages and
                      relief as a court except that, in the case of injunctive
                      or declaratory relief, an arbitrator cannot issue an
                      injunction or declaratory judgment that extends beyond you
                      and Buy on Trust and affects Buy on Trust obligations or
                      liability to other parties. An arbitrator can, however,
                      issue an injunction or declaratory judgment on your claims
                      so long as it is limited to providing you with individual
                      relief. Arbitration is more informal than litigation and
                      generally provides a quicker and more cost-effective way
                      to resolve Disputes, but there is only limited discovery
                      in arbitration, and there is only very limited review of
                      an arbitrator’s decision.
                    </p>
                  </li>
                  <li>
                    <b>ARBITRATION PROCEDURES AND RULES</b>
                    <p className="subpage__paragraph">
                      You and Buy on Trust agree that this Arbitration Agreement
                      is subject to and governed by the Federal Arbitration Act,
                      9 U.S.C. Section 1, et seq. Arbitration shall be conducted
                      by the American Arbitration Association (“AAA”) pursuant
                      to its Commercial Arbitration Rules and Consumer Related
                      Disputes Supplemental Procedures. Those rules are
                      available at www.adr.org. or by calling the AAA at
                      1-800-778-7879. A single arbitrator will decide our
                      Disputes. To initiate an arbitration, you must file a
                      demand for arbitration with the AAA, following the AAA’s
                      rules and procedures as set forth at www.adr.org.
                      Arbitration shall be held in the state in which you reside
                      at the time you initiate the arbitration. You may choose
                      to have the arbitration conducted by telephone, based on
                      written submissions, or in person in the county where you
                      live or at another mutually agreed location.
                    </p>
                  </li>
                  <li>
                    <b>COSTS AND ATTORNEY’S FEES IN ARBITRATION</b>
                    <p className="subpage__paragraph">
                      If you file an arbitration claim against Buy on Trust
                      hereunder, Buy on Trust agrees to pay the AAA initial
                      filing fee on your behalf for claims totaling less than
                      $1,000, unless the arbitrator determines that the claims
                      are frivolous. Except for such initial filing fee, you and
                      we agree that we will each be responsible for our own
                      costs and attorneys’ fees in arbitration. The arbitrator’s
                      fees will be divided between us as set forth in the AAA’s
                      Consumer Related Disputes Supplemental Procedures. If you
                      are the prevailing party in the arbitration, Buy on Trust
                      agrees to pay you for any arbitrator fees you paid in the
                      arbitration or to pay the arbitrator for any fees owed by
                      you. If you prevail in the arbitration and are entitled to
                      recover your attorneys’ fees or costs under an applicable
                      statute or common law doctrine, then the arbitrator has
                      the authority to award you such fees and costs but is not
                      required to do so. Buy on Trust agrees that it will not
                      seek to recover its attorneys’ fees and costs from you
                      even if it prevails in the arbitration and is entitled to
                      recover those fees and costs under an applicable statute
                      or common law doctrine, unless the arbitrator determines
                      that the claims are frivolous.
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <b>GENERAL</b>
                <p className="subpage__paragraph">
                  Use of the Buy on Trust Services is unauthorized in any
                  jurisdiction that does not give effect to all provisions of
                  these Terms of Service. By using the Buy on Trust Services,
                  you agree that the Federal Arbitration Act, applicable federal
                  law, and the laws of the State of Colorado, U.S.A. without
                  regard to its conflict of law provisions, will govern these
                  Terms of Service and any dispute that might arise between you
                  and Buy on Trust. Except with respect to Disputes to be
                  resolved through an arbitration process in accordance with the
                  Arbitration Agreement contained above, you and Buy on Trust
                  hereby consent and submit to the exclusive jurisdiction of the
                  courts located in Boulder County, Colorado to resolve any
                  Dispute arising out of the Agreement. YOU HEREBY KNOWINGLY,
                  VOLUNTARILY AND INTENTIONALLY WAIVE ANY RIGHT YOU MAY HAVE TO
                  A TRIAL BY JURY IN RESPECT OF ANY LITIGATION (INCLUDING, BUT
                  NOT LIMITED TO, ANY CLAIMS, COUNTERCLAIMS, CROSS-CLAIMS, OR
                  THIRD-PARTY CLAIMS) ARISING OUT OF, UNDER OR IN CONNECTION
                  WITH THIS AGREEMENT. YOU AGREE THAT ANY CAUSE OF ACTION YOU
                  MAY HAVE ARISING OUT OF OR RELATED TO THIS AGREEMENT, OR THE
                  BUY ON TRUST SERVICES MUST BE COMMENCED WITHIN ONE (1) YEAR
                  AFTER SUCH CAUSE OF ACTION ACCRUES. AFTER SUCH PERIOD, SUCH
                  CAUSE OF ACTION SHALL BE PERMANENTLY BARRED. You agree that
                  you are not entering into a joint venture, partnership,
                  employment, or agency relationship with us as a result of
                  these Terms of Service or use of the Buy on Trust Services.
                  Our performance of these Terms of Service is subject to
                  existing laws and legal process, and nothing contained in
                  these Terms of Service are in derogation of our right to
                  comply with governmental, court and law enforcement requests
                  or requirements relating to your use of the Buy on Trust
                  Services or information provided to or gathered by us with
                  respect to such use. No failure or delay on our part to
                  exercise or enforce any right or provision under these Terms
                  of Service will operate as a waiver of such provision or any
                  rights, nor will any single or partial exercise of any right
                  preclude any other or further exercise of any other right. If
                  any part of these Terms of Service is determined to be invalid
                  or unenforceable pursuant to applicable law including, but not
                  limited to, the warranty disclaimers and liability limitations
                  set forth above, then the invalid or unenforceable provision
                  shall be deleted and the remainder of the Terms of Service
                  shall be in full force and effect. The Section titles in these
                  Terms of Service are for convenience only and have no legal or
                  contractual effect. These Terms of Service operate to the
                  fullest extent permissible by law. These Terms of Service and
                  our Privacy Policy constitute the entire agreement between the
                  user and us with respect to the Buy on Trust Services and it
                  supersedes all prior or contemporaneous communications and
                  proposals, whether electronic, oral or written, between the
                  user and us with respect to the Buy on Trust Services. This
                  Agreement shall not be assignable by you, either in whole or
                  in part. Buy on Trust reserves the right to assign its rights
                  and obligations under this Agreement. It is the express wish
                  of the parties that this agreement and all related documents
                  be drawn up in English.
                </p>
              </li>
              <li>
                <b>CUSTOMER TRANSACTION - CONFLICTS</b>
                <p className="subpage__paragraph">
                  You expressly agree that these Terms of Service for use of the
                  Buy on Trust Services may be independent and separate from the
                  contract for a purchase or lease transaction that you enter
                  into with us. Nothing in these Terms of Service should be
                  interpreted to change or modify any terms of that contract, or
                  the Buy on Trust Arbitration Agreement entered into in
                  connection with a purchase or lease contract, or to create a
                  separate contract between you and us regarding the purchase or
                  lease transaction. In the event of any conflict between these
                  Terms of Service and the contract covering your purchase or
                  lease transaction or the Buy on Trust Arbitration Agreement
                  entered into in connection with a purchase or lease contract,
                  the contract covering your purchase or lease transaction and
                  such Buy on Trust Arbitration Agreement, will apply and
                  prevail.
                </p>
              </li>
              <li>
                <b>ELECTRONIC COMMUNICATIONS</b>
                <p className="subpage__paragraph">
                  When you use the Buy on Trust Services, or send e-mails, text
                  messages, and other communications from your desktop or mobile
                  device to us, you may be communicating with us electronically.
                  You consent to receive communications from us electronically,
                  such as e-mails, texts, mobile push notices, or notices and
                  messages on or through the Buy on Trust Services, and you can
                  retain copies of these communications for your records. You
                  agree that all agreements, notices, disclosures, and other
                  communications that we provide to you electronically satisfy
                  any legal requirement that such communications be in writing.
                  Your cellular provider’s message & data rates may apply to
                  your use of the Buy on Trust Services, and payment is your
                  responsibility.
                </p>
              </li>
              <li>
                <b>Text/SMS Wireless Calling Policy</b>
                <p className="subpage__paragraph">
                  When you provide Buy on Trust with your mobile phone number,
                  you expressly consent to Buy on Trust sending you text
                  messages to the phone number designated regarding lease deals,
                  merchandise, surveys, and special offers. You also expressly
                  consent to receiving texts messages, as well as auto-dialed,
                  pre-recorded calls to your wireless and other numbers
                  regarding account management and payments (described further
                  below in “Content of Text Messages and Wireless Calls”). Your
                  cellular provider’s message & data rates may apply, and
                  payment is your responsibility. Text messages will be sent via
                  automatic telephone dialing system or through other automated
                  software. Buy on Trust cannot guarantee message delivery. Your
                  consent to receive marketing text messages does not mean you
                  are obligated to make a purchase or lease products, nor is
                  providing your consent to receiving marketing text messages a
                  condition of any purchase or lease. You agree to notify us
                  immediately if you change your mobile phone number. If we
                  modify this Text/SMS Wireless Calling Policy, we will notify
                  you by sending you a text message with a link to the new
                  policy. We may terminate our text message program at any time.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  Content of Text Messages and Wireless Calls: In addition to
                  agreeing to receive text messages regarding lease deals,
                  merchandise, surveys, and special offers, you agree that Buy
                  on Trust or its agent(s) may contact you regarding account
                  management or payments for leased merchandise at any mobile
                  phone number(s) you provide to Buy on Trust or that Buy on
                  Trust obtains for you. This consent includes telephone calls
                  or SMS text messages placed using an artificial or
                  pre-recorded voice or an automatic telephone dialing system or
                  predictive dialer. You understand that, when you receive such
                  calls, texts, or emails, you may incur a charge from the
                  company that provides you with telecommunications, wireless
                  and/or internet services. You agree that Buy on Trust will not
                  be liable to you in any way for calls or texts placed pursuant
                  to this consent.
                </p>
              </li>
              <li>
                <b>SANCTIONS AND EXPORT POLICY</b>
                <p className="subpage__paragraph">
                  You may not use any of the Buy on Trust Services if you are
                  the subject of U.S. sanctions or of sanctions consistent with
                  U.S. law imposed by the governments of the country where you
                  are using the Buy on Trust Services. You must comply with all
                  U.S. or other export and re-export restrictions that may apply
                  to goods, software (including Buy on Trust Software),
                  technology and services.
                </p>
              </li>
              <li>
                <b>QUESTIONS</b>
                <p className="subpage__paragraph">
                  For questions about these Terms of Service, the Buy on Trust
                  Services, or if you believe that we have not adhered to these
                  Terms of Service, please contact us at 1434 Spruce Street,
                  Suite 100, Boulder, CO 80302 or at{' '}
                  <a
                    href="mailto:info@buyontrust.com"
                    style={{
                      marginLeft: '2px',
                      color: '#4f4f4f',
                      fontWeight: '600'
                    }}>
                    info@buyontrust.com
                  </a>
                  . We will use commercially reasonable efforts to respond to
                  and remedy any problems.
                </p>
              </li>
            </ol>
            <br></br>
            <p className='subpage__paragraph last-update note'>Last updated August 6, 2024</p>
            <br></br>
            <i className="subpage__paragraph note center">
              *This estimated payment is only an estimate. Not all applicants
              are approved or qualify for these terms. Actual terms will be in
              the lease agreement. Not available in MN, NJ, WI & WY.
            </i>
          </div>
        </div>
      </div>
    </main>
    </>
  );
}
